/**
 * Component class barrel export.
 * All decorated component classes for the engine.
 */

export { AudioListener } from './AudioListener.component';
export { AudioSource } from './AudioSource.component';
export { BoxCollider2D } from './BoxCollider2D.component';
export { BuoyancyZone2D } from './BuoyancyZone2D.component';
export { Camera2D } from './Camera2D.component';
export { CameraRig, PositionControlMode, RotationControlMode, StandbyUpdateMode, BlendHint } from './CameraRig.component';
export { CapsuleCollider2D } from './CapsuleCollider2D.component';
export { CircleCollider2D } from './CircleCollider2D.component';
export { ConvexCollider2D } from './ConvexCollider2D.component';
export { GravityZone2D } from './GravityZone2D.component';
export { PolygonCollider2D } from './PolygonCollider2D.component';
export { RigidBody2D } from './RigidBody2D.component';
export { Spline2D, SplineEvaluator, createSplineEvaluator } from './Spline2D.component';
export type { SplineType, ResolvedSplinePoint } from './Spline2D.component';
export { SpriteRenderer } from './SpriteRenderer.component';
export { Text, TextAlign } from './Text.component';
export { UICanvas, UIScaleMode } from './UICanvas.component';
export { SurfaceEffector2D } from './SurfaceEffector2D.component';
export { TargetGroup, evaluateTargetGroup } from './TargetGroup.component';
export { Transform as TransformComponent } from './Transform.component';
export { VFXEmitter } from './VFXEmitter.component';
export { WindZone2D } from './WindZone2D.component';

// Lighting
export { PointLight2D } from './PointLight2D.component';
export { SpotLight2D } from './SpotLight2D.component';
export { DirectionalLight2D } from './DirectionalLight2D.component';
export { AmbientLight2D } from './AmbientLight2D.component';
